module.exports = __webpack_public_path__ + "img/multiTank_mini.3f12e2a6.png";